const modal = {
  cancelButton: 'Ignorar',
  confirmButton: 'Confirmar',
  confirmChange: {
    title: 'Confirmar mudança',
    body: 'Você tem certeza de que deseja fazer essa mudança?',
    confirmButton: 'Confirmar',
    cancelButton: 'Cancelar',
    verificationPlaceholder: 'Digite a frase de verificação',
  },
};

export default modal;
